import EmployeeRoll from '../components/employee-roll';
import LendingTreeCarousel from '../components/lending-tree-carousel';
import Navigation from '../components/navigation';
import Tabs5050 from '../components/tabs5050';
import AppFeature from '../components/app-feature';

/* Import Swiper modules */
import Swiper, { Autoplay, Pagination } from 'swiper';

/* Make Swiper use the module(s) */
Swiper.use([Autoplay, Pagination]);

export default {
  init() {
    // JavaScript to be fired on all pages.

    /**
     * Initialize the EmployeeRoll block JS.
     */
    const employee = new EmployeeRoll();
    employee.openBtn.on('click', function (event) {
      event.preventDefault();
      employee.currentEmployee = event.target;
      employee.initModal();
    });

    /**
     * Initialize the Lending Tree Carousel Swiper
     */
    const carousel = new LendingTreeCarousel();
    carousel.init();

    /**
     * Construct and initialize the Navigation object.
     */
    const navigation = new Navigation(
      this.nav = $( '.nav' ),
      this.navToggle = $( '.nav-toggle' ),
      this.dropdown = $( '.dropdown' ),
      this.dropdownToggle = $( '.dropdown-toggle' ),
      this.dropdownMenu = $( '.dropdown-menu' ),
      this.dropdownItem = $( '.dropdown-item' )
    );

    navigation.init();

    /*
    * Initialize the Lending Tree Carousel Swiper
    */
    const tabsSlider = new Tabs5050();
    tabsSlider.init();

    /*
    * Initialize the App Feature JS
    */
    const FeaturedApp = new AppFeature();
    FeaturedApp.init();
  },

  finalize() {
    // JavaScript to be fired on all pages, after page specific JS is fired.
  },
};



// WEBPACK FOOTER //
// ./scripts/routes/common.js